import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

import LogbookSignatureModal from '../LogbookAppIntegration/LogbookSignatureModal';

class AircraftLogbooksAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      aircraft_id: null,
      date: null,
      aircrafts_list: [],
      logbook_app: 0,
      email: '',
      password: '',
      showLogbookSignatureModal: false,
      preValidationStatus: null,
      preValidationMessage: '',
      preValidationItems: [],
      preValidationLoading: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.logbookIntegration = this.logbookIntegration.bind(this);
    this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
    this.runPreValidation = this.runPreValidation.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change, () => {
      if (name === 'date') {
        this.runPreValidation();
      }
    });
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectAircraftChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change, () => {
      this.runPreValidation();
    });

    if(event == null) {
      return;
    }

    // Captura os dados da aeronave selecionada para verificar se tem integração com o Logbook App
    var aircraft_id = event.value;
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = config.get('api') + '/aeronave/' + aircraft_id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ logbook_app: responseJson.data.main.use_logbook_external });
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.runPreValidation();
      });
    });
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronaves/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ aircrafts_list: responseJson.data });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  runPreValidation() {
    const aircraft_id = this.state.aircraft_id;
    const date = this.state.date;

    if (!aircraft_id || !date || date.length !== 10) {
      this.setState({
        preValidationStatus: null,
        preValidationMessage: '',
        preValidationItems: [],
        preValidationLoading: false,
      });
      return;
    }

    this.setState({ preValidationLoading: true });
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/diario/validar', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: JSON.stringify({
          aircraft_id: aircraft_id,
          date: date,
        }),
      }).then((response) => response.json()).catch((error) => {
        console.error(error);
        return { status: 'error', message: 'Não foi possível validar a abertura do diário.', data: { pendencias: [] } };
      }).then((responseJson) => {
        const pendencias = responseJson && responseJson.data && responseJson.data.pendencias ? responseJson.data.pendencias : [];
        self.setState({
          preValidationStatus: responseJson.status || 'error',
          preValidationMessage: responseJson.message || '',
          preValidationItems: pendencias,
          preValidationLoading: false,
        });
      }).catch((error) => {
        console.error(error);
        self.setState({
          preValidationStatus: 'error',
          preValidationMessage: 'Não foi possível validar a abertura do diário.',
          preValidationItems: [],
          preValidationLoading: false,
        });
      });
    });
  }

  add() {
    this.handleAlert('', '', 'open');
    var datasave = {
      aircraft_id: this.state.aircraft_id,
      date: this.state.date,
      email: this.state.email,
      password: this.state.password
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/diario', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/aeronave/diario/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Integração com o Logbook App
  logbookIntegration(event) {
    event.preventDefault();
    // Se tiver integração com o Logbook App
    if (this.state.logbook_app == 1) {
      // Abrimos o modal para solicitar as credenciais do Logbook App
      this.setState({ showLogbookSignatureModal: true });
    } else {
      // Se não tiver integração, chama a função de cadastro diretamente
      this.add();
    }
  }

  handleLogbookSignatureSubmit(credentials) {
    // Recebe { email, password } do modal e atualiza o state
    this.setState({
      email: credentials.email,
      password: credentials.password,
      showLogbookSignatureModal: false
    }, () => {
      // Após informar as credenciais, chama a função de cadastro
      this.add();
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar diário de bordo</h3>
      <Link to="/aeronave/diarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      {(this.state.aircraft_id && this.state.date) &&
        <div className="panel panel-info">
          <div className="panel-heading">
            <strong>Checagem prévia do diário</strong>
          </div>
          <div className="panel-body">
            {this.state.preValidationLoading &&
              <p><i className="fa fa-spinner fa-spin"></i> Validando condições de abertura…</p>
            }
            {!this.state.preValidationLoading && this.state.preValidationStatus === 'success' &&
              <p><i className="fa fa-check text-success"></i> {this.state.preValidationMessage || 'Nenhuma restrição encontrada para a data informada.'}</p>
            }
            {!this.state.preValidationLoading && this.state.preValidationStatus === 'warning' &&
              <div>
                <p><i className="fa fa-exclamation-triangle text-warning"></i> {this.state.preValidationMessage}</p>
                <ul className="list-unstyled" style={{ marginBottom: 0 }}>
                  {this.state.preValidationItems.map((item, index) => (
                    <li key={index}><i className="fa fa-minus text-warning"></i> {item}</li>
                  ))}
                </ul>
              </div>
            }
            {!this.state.preValidationLoading && this.state.preValidationStatus === 'error' && this.state.preValidationMessage !== '' &&
              <p><i className="fa fa-exclamation-circle text-danger"></i> {this.state.preValidationMessage}</p>
            }
            {!this.state.preValidationLoading && this.state.preValidationStatus === null &&
              <p>Selecione a aeronave e informe a data para verificar se o diário pode ser aberto.</p>
            }
          </div>
        </div>
      }
      <form onSubmit={this.logbookIntegration}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Aeronave:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={'Selecionar matrícula de aeronave'}
                onChange={this.handleSelectAircraftChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data:</label>
              <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="dd/mm/aaaa" required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar diário de bordo</button>
          </div>
        </div>
      </form>
    </div>
    {/* Modal de assinatura do LogbookApp */}
    <LogbookSignatureModal
      show={this.state.showLogbookSignatureModal}
      onHide={() => this.setState({ showLogbookSignatureModal: false })}
      onSubmit={this.handleLogbookSignatureSubmit}
      title="Consultar Logbook App"
      subtitle="Informe suas credenciais para que possamos consultar o Logbook App."
      confirmation="Confirmar"
    />
  </div>
</div>
    );
  }
}

export default AircraftLogbooksAdd;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/AircraftLogbooksAdd.js